import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './style.scss'

export default class CountryCell extends Component {
    static propTypes = {
        country: PropTypes.string.isRequired,
    }

    render() {
        const { country } = this.props

        return (
            <div className={'import-group-result-country-cell'}>
                <div className={cx('flag-icon', `flag-icon-${country}`)} />
            </div>
        )
    }
}
